const {bind} = require('./lib/bind')

document.addEventListener("DOMContentLoaded",function(){
  if(!document.getElementById('promo-dismiss')) return

  bind(document.getElementById('promo-dismiss'), 'click', function() {
    // Hide for 5 days
    document.cookie = `promo=dismissed; Path=/;Expires=${new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 5).toUTCString()}`
  })
})